<script lang="ts">
    import Text from "@components/Typography/Text.svelte";

    type Items = Array<{
        percentageProgress: number;
        title: string;
        value: number;
        id: number;
    }>;

    //Props
    export let items: Items;
    export let progress: number;
    export let dataGwSelector: string;
    export let currentTierId: number | undefined;

    const isMarkFilled = ({
        progress,
        value,
        index,
    }: {
        progress: number;
        value: number;
        index: number;
    }): boolean => {
        if (index === 0) return progress > value;

        return progress >= value;
    };
</script>

<div class="gw-multi-progress-bar">
    {#each items as item, index (item.id)}
        <div
            class="gw-multi-progress-bar__section"
            data-gw-selector={dataGwSelector}
            data-gw-tier-id={item.id}
            data-gw-is-current-tier={item.id === currentTierId}
        >
            <div
                class="gw-multi-progress-bar__section-mark"
                class:gw-multi-progress-bar__section-mark--filled={isMarkFilled(
                    {
                        progress,
                        value: item.value,
                        index,
                    }
                )}
            />
            {#if index < items.length - 1}
                <div
                    class="gw-multi-progress-bar__section-track"
                    role="progressbar"
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                >
                    <div
                        style="width: {item.percentageProgress}%"
                        class="gw-multi-progress-bar__section-track--fill"
                    />
                </div>
            {/if}
            <div class="gw-multi-progress-bar__section-title">
                <slot item={item.value} />
                <Text component="span" variant="primary" weight="semibold">
                    {item.title}
                </Text>
            </div>
        </div>
    {/each}
</div>

<style lang="postcss">
    .gw-multi-progress-bar {
        display: flex;

        &__section {
            position: relative;
            flex: 1 1 auto;

            &:first-child &-title {
                left: -10px;
                transform: unset;
                right: auto;
                align-items: start;
            }

            &:last-child {
                flex: unset;

                .gw-multi-progress-bar__section-title {
                    left: auto;
                    transform: unset;
                    right: -10px;
                    align-items: end;
                }
            }

            &-mark {
                position: absolute;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background-color: var(--gw-empty-progress-mark-bg-color);

                &--filled {
                    background-color: var(--gw-filled-progress-bar-bg-color);
                }
            }

            &-track {
                height: 8px;
                background-color: var(--gw-empty-progress-mark-bg-color);

                &--fill {
                    height: 100%;
                    background-color: var(--gw-filled-progress-bar-bg-color);
                }
            }

            &-title {
                position: absolute;
                top: calc(100% + 15px);
                transform: translateX(-50%);
                max-width: 120px;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;

                :global(span:first-child) {
                    white-space: nowrap;
                }
            }
        }
    }
</style>
